import { VFC } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import WorkflowRoutes from 'workflow/Routes'
import WorkflowmodelRoutes from 'workflowmodel/Routes'
import InteractionRoutes from 'interaction/Routes'
import MasterdataRoutes from 'masterdata/Routes'
import TaskRoutes from 'task/Routes'
import ProcessModelRoutes from 'processmodel/Routes'
import TokenRoutes from 'token/Routes'

const ApplicationRouter: VFC = () => {
  return (
    <Routes>
      <Route path='workflow/*' element={<WorkflowRoutes />} />
      <Route path='workflowmodel/*' element={<WorkflowmodelRoutes />} />
      <Route path='interaction/*' element={<InteractionRoutes />} />
      <Route path='task/*' element={<TaskRoutes />} />
      <Route path='masterdata/*' element={<MasterdataRoutes />} />
      <Route path='processmodel/*' element={<ProcessModelRoutes />} />
      <Route path='token/*' element={<TokenRoutes />} />

      <Route path='/' element={<Navigate to='/workflowmodel/list' />} />
    </Routes>
  )
}

export default ApplicationRouter
